import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { SideNavComponent } from './side-nav.component';
import { EventService } from '../../services/event.service';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { CalibrantLoadModule } from '../shared/calibrant-load/calibrant-load.module';
import { MatTreeModule } from '@angular/material/tree';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import {SideNavService} from "../../services/side-nav.service";
import {FormsModule, ReactiveFormsModule} from "@angular/forms";
import {MatListModule} from "@angular/material/list";
import {MatAutocompleteModule} from "@angular/material/autocomplete";
import {MatFormFieldModule} from "@angular/material/form-field";
import { MatOptionModule, MatRipple } from '@angular/material/core';
import {MatInputModule} from "@angular/material/input";
import {MatSidenavModule} from "@angular/material/sidenav";
import {MatSelectModule} from "@angular/material/select";
import { TruncatePipe } from '../shared/truncate.pipe';
import { MatTooltip } from '@angular/material/tooltip';
import {TreeModule} from "tree/dist/tree";
@NgModule({
    imports: [
        CommonModule,
        RouterModule,
        FontAwesomeModule,
        NgbModule,
        CalibrantLoadModule,
        MatTreeModule,
        MatIconModule,
        MatButtonModule,
        FormsModule,
        MatListModule,
        MatAutocompleteModule,
        MatFormFieldModule,
        MatOptionModule,
        ReactiveFormsModule,
        MatInputModule,
        MatSidenavModule,
        MatSelectModule,
        MatRipple,
        TruncatePipe,
        MatTooltip,
        TreeModule,
    ],
  declarations: [
    SideNavComponent,
  ],
  providers: [
    EventService,
    SideNavService
  ],
  exports: [
    SideNavComponent
  ]
})
export class SideNavModule { }
